if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      this.bindEvents();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    bindEvents() {
      // The panel appears as soon as the add-to-cart form scrolls out of view, on BOTH breakpoints.
      //
      // Desktop used to watch the whole `.product-info` column and only reveal the panel once that
      // column stopped intersecting. On this store that column also holds the Features, Shipping &
      // Returns and FAQ accordions, so it stayed hidden for thousands of pixels after the buy
      // button had gone — leaving no add-to-cart anywhere in the viewport. Mobile already keyed off
      // the form, which is the correct reference; both now do.
      //
      // `.product-info` is kept only as a fallback for layouts with no <product-form> at all
      // (enquire-only products), so those still get a panel rather than none.
      this.trigger = this.productForm || this.productInfo;
      if (!this.trigger) return;

      // Deliberately position-based rather than IntersectionObserver-based. An observer only fires
      // when the element *crosses* the boundary, so any jump that skips the form entirely — an
      // in-page anchor (this panel's own "Choose options" link), a restored scroll position on back
      // navigation, or a deep link — leaves the panel in whatever state it was last in. Measuring
      // the position on each frame cannot desync.
      this.onScroll = () => {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this.rafId = null;
          this.updateVisibility();
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      window.addEventListener('scroll', StickyAtcPanel.handleScroll);

      this.updateVisibility();
    }

    /**
     * Shows the panel once the trigger has passed above the top of the viewport.
     */
    updateVisibility() {
      if (!this.trigger) return;
      // bottom > 0 means the trigger has not yet scrolled above the viewport, so stay hidden.
      this.classList.toggle('sticky-atc-panel--out', this.trigger.getBoundingClientRect().bottom > 0);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
